import React from 'react';
import {observable, action, computed, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import * as data from '../../data';
import {checkout} from '../../../api';
import {CheckoutInputElement} from '../inputs/checkoutInputs';
import * as checkoutUtil from '../../checkoutUtil';
import ModalSimple from '../../../global/modal-simple';
import s from '../../s';
declare var modalOpen: any;
declare var Awesomplete: any;

@observer
export default class ShippingWrite extends React.Component {
    @observable loading: boolean = false;
    @observable focusedCountry: boolean = false;
    @observable focusedState: boolean = false;
    @observable focusedAddressBook: boolean = false;
    @observable focusedAddressType: boolean = false;

    constructor(props) {
        super(props);
        this.handleAddressTypeChange = this.handleAddressTypeChange.bind(this);
        this.save = this.save.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);
        this.syncMore = this.syncMore.bind(this);
        this.syncMoreCompany = this.syncMoreCompany.bind(this);
        this.placesInit = this.placesInit.bind(this);
        this.handleChangeAddressBook = this.handleChangeAddressBook.bind(this);
        this.initShipAddressBook = this.initShipAddressBook.bind(this);
        this.handleChangeShippingState = this.handleChangeShippingState.bind(this);
        this.loading = false;
        s.places_start = new Date();
        s.places_end = new Date();
        makeObservable(this);
    }

    async componentDidMount() {
        if (window.innerWidth < 960) {
            await checkout('places-autocomplete');
            await this.placesInit();
        }
        this.initShipAddressBook();
    }

    @action
    handleChangeCountry = (e: React.ChangeEvent<HTMLSelectElement>) => {
        store.uiCheckout.stateRequiredShip = e.target.value === 'US' || e.target.value === 'CA';
        store.checkout.ship.addr.country.value = e.target.value;
        store.checkout.ship.addr.state.valid.isError = false;
    };

    @action
    handleChangeAddressBook = (e: React.ChangeEvent<HTMLSelectElement>) => {
        store.checkout.ship.AddressID = parseInt(e.target.value, 10);
        store.setShippingAddressToBook();
    };

    @action
    initShipAddressBook = () => {
        let initToShip = store.checkout.isMyFrames && !store.checkout.myframes_isDropShip && store.checkout.AddressBookAddresses != null && store.checkout.AddressBookAddresses.length > 0;
        if (!initToShip) {
            initToShip = !store.checkout.myframes_isDropShip && store.checkout.AddressBookAddresses != null && store.checkout.AddressBookAddresses.length > 0 && store.checkout.ship.AddressID < 1;
        }

        if (initToShip) {
            const a = store.checkout.AddressBookAddresses.filter(x => x.isShipping);
            if (a.length > 0) {
                store.checkout.ship.AddressID = a[0].AddressID;
                store.setShippingAddressToBook();
            }
        }

        if (store.checkout.isMyFrames && !store.checkout.myframes_isDropShip && initToShip) {
            const a = store.checkout.AddressBookAddresses.filter(x => x.isBilling);
            if (a.length > 0) {
                store.checkout.billing.AddressID = a[0].AddressID;
                store.setBillingAddressToBook();
            }
        }
    };

    @computed get isCountryWithStates() {
        try {
            return (
                store.checkout.ship.addr.country.value.toLowerCase() === 'us' ||
                store.checkout.ship.addr.country.value.toLowerCase() === 'ca' ||
                store.checkout.ship.addr.country.value.toLowerCase() === 'jp' ||
                store.checkout.ship.addr.country.value.toLowerCase() === 'gb' ||
                store.checkout.ship.addr.country.value.toLowerCase() === 'de'
            );
        } catch {
            return true;
        }
    }

    @action
    handleAddressTypeChange = (e: any) => {
        store.checkout.ship.addressType = parseInt(e.target.value, 10);
    };

    @action
    handleChangeShippingState = (e: any) => {
        store.checkout.ship.addr.state.value = e.target.value;
        let _ii = e.target.options.selectedIndex;
        let _id = parseInt(e.target.options[_ii].getAttribute('data-id'), 10);
        if (_id === 1) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Africa';
        } else if (_id === 2) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Americas';
        } else if (_id === 3) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Canada';
        } else if (_id === 4) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Europe';
        } else if (_id === 5) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Middle East';
        } else if (_id === 6) {
            store.checkout.ship.addr.companyName.value = 'Armed Forces Pacific';
        } else {
            if (store.checkout.ship.addr.companyName.value.startsWith('Armed')) {
                store.checkout.ship.addr.companyName.value = '';
                store.checkout.ship.addr.addrShowMoreCompany = false;
            }
        }
        store.checkout.ship.addr.state.valid.isError = false;
    };

    @action
    save = async () => {
        if (store.checkout.ship.addr.state.value === 'AL1') {
            store.checkout.ship.addr.state.valid.isError = true;
            store.checkout.ship.addr.state.valid.msg = 'Please select a state/region';
            return;
        }
        this.loading = true;
        store.checkout.ship.ignoreCorrection = false;

        let success = await checkout('cc-ship-addr-submit');
        checkoutUtil.checkDefaultShipping();
        success = await checkout('cc-ship-select-no-change');
        runInAction(() => {
            // approved ria
            this.loading = false;
        });
    };

    @action
    syncMore = async () => {
        store.checkout.ship.addr.addrShowMore = true;
        await checkout('checkout-sync');
    };

    @action
    syncMoreCompany = async () => {
        store.checkout.ship.addr.addrShowMoreCompany = true;
        await checkout('checkout-sync');
    };

    @action
    placesInit = async () => {
        var x = document.getElementsByClassName('google-places');

        // console.log(x);
        for (var i = 0; i < x.length; i++) {
            const ele = x[i] as HTMLInputElement;
            // console.log(ele);
            const a = document.createElement('DIV');
            a.setAttribute('id', `${ele.id}-autocomplete-list`);
            a.setAttribute('class', 'autocomplete-items');
            a.setAttribute('role', 'listbox');
            (ele.parentNode as Node).appendChild(a);
            ele.dataset.ac = `${ele.id}-autocomplete-list`;

            const inputHandler = function (e) {
                const _val = e.val() as string;
            };

            ele.addEventListener('input', function (evt) {
                clearTimeout(s.places_throttle);
                s.places_throttle = setTimeout(async () => {
                    await checkout('places-autocomplete');
                    // _ac[this.id].list = store.checkout.ship.google_autocomplete;
                    const result = store.checkout.ship.google_autocomplete;
                    const xx = document.getElementsByClassName('google-places');
                    a.innerHTML = '';
                    // console.log(result);

                    for (i = 0; i < result.length; i++) {
                        const b = document.createElement('DIV');
                        b.innerHTML = result[i].description;
                        b.dataset.placeid = result[i].place_id;
                        /*execute a function when someone clicks on the item value (DIV element):*/
                        b.addEventListener('click', async function (e: any) {
                            // console.log(e.target.dataset.placeid);
                            store.checkout.ship.google_autocomplete_placeid = e.target.dataset.placeid;
                            await checkout('places-autocomplete-select');
                            a.innerHTML = '';

                            try {
                                // set address
                                let street_number: string = '';
                                let street_route: string = '';
                                let street2_room: string = '';
                                let street2_floor: string = '';
                                let street2_sub: string = '';
                                let postal_first: string = '';
                                let postal_last: string = '';
                                let city: string = '';
                                let _state: string = '';
                                let _country: string = '';
                                // console.log('fff');
                                // console.log(store.checkout.ship.google_autocomplete_details);
                                for (let i = 0; i < store.checkout.ship.google_autocomplete_details.length; i++) {
                                    const d = store.checkout.ship.google_autocomplete_details[i];
                                    for (let z = 0; z < d.types.length; z++) {
                                        const t = d.types[z].toLowerCase();
                                        if (t === 'street_number') {
                                            street_number = d.long_name;
                                        } else if (t === 'route') {
                                            street_route = d.short_name;
                                        } else if (t === 'locality') {
                                            city = d.long_name;
                                        } else if (t === 'administrative_area_level_1') {
                                            _state = d.short_name;
                                        } else if (t === 'country') {
                                            _country = d.short_name;
                                        } else if (t === 'room') {
                                            street2_room = d.long_name;
                                        } else if (t === 'subpremise') {
                                            street2_sub = d.long_name;
                                        } else if (t === 'floor') {
                                            street2_floor = d.long_name;
                                        } else if (t === 'postal_code') {
                                            postal_first = d.long_name;
                                        } else if (t === 'postal_code_suffix') {
                                            postal_last = d.long_name;
                                        }
                                    }
                                }

                                store.checkout.ship.addr.address1.value = `${street_number} ${street_route}`;
                                store.checkout.ship.addr.city.value = city;
                                store.checkout.ship.addr.state.value = _state;
                                store.checkout.ship.addr.country.value = _country;
                                if (postal_first.length > 0) {
                                    store.checkout.ship.addr.postalCode.value = postal_first;
                                }
                                if (postal_last.length > 0) {
                                    store.checkout.ship.addr.postalCode.value += `-${postal_last}`;
                                }
                            } catch (err4) {
                                console.error(err4);
                            }
                        });
                        b.setAttribute('aria-label', `Select Automatically Completed Address: ${result[i].description}`);
                        b.setAttribute('role', 'option');
                        a.appendChild(b);
                    }

                    const b = document.createElement('DIV');
                    b.innerHTML = `Powered by <img src="https://${store.Portal.CDNDomain}/images/cached/general/google_on_white.png" style="width:auto;" alt="Google" />`;
                    b.style.fontStyle = 'italic';
                    b.style.paddingLeft = '6px';
                    b.style.fontSize = '14px';
                    a.appendChild(b);

                    setTimeout(function () {
                        a.innerHTML = '';
                    }, 7000);
                }, 100);
            });
        }
    };

    // todo APO, privacy warning, country/international
    render() {
        return (
            <div className="shipping-write">
                <div className="">
                    <div className="row">
                        <div className="col-12 required">* Required</div>
                    </div>

                    {/* Address Book */}
                    {store.checkout.AddressBookAddresses != null && store.checkout.AddressBookAddresses.length > 0 && (
                        <div className={'col-12 mb-2'}>
                            {store.checkout.ab < 0 && <div className={this.focusedAddressBook ? 'input-label input-label-focused' : 'input-label'}>Address Book</div>}
                            <div className="form-floating">
                                <select
                                    className="form-select"
                                    name="shipping-address-book"
                                    onFocus={() => (this.focusedAddressBook = true)}
                                    onBlur={() => (this.focusedAddressBook = false)}
                                    autoComplete="off"
                                    value={store.checkout.ship.AddressID}
                                    aria-label="Address Book"
                                    onChange={e => this.handleChangeAddressBook(e)}
                                >
                                    <option
                                        value={-1}
                                        key={-1}
                                    >
                                        Select Address
                                    </option>
                                    {store.checkout.AddressBookAddresses.map(e => (
                                        <option
                                            value={e.AddressID}
                                            key={e.AddressID}
                                        >
                                            {e.Nickname}
                                        </option>
                                    ))}
                                </select>
                                <label htmlFor="shipping-address-book">Address Book</label>
                            </div>
                        </div>
                    )}

                    {/* Shipping first and last names */}
                    <div className="row pad-top">
                        <div className="col-12 col-sm-6">
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.firstName}
                                label="First Name"
                                required={true}
                                ariaLabel="Shipping First Name"
                            />
                        </div>
                        <div className="col-12 col-sm-6">
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.lastName}
                                required={true}
                                ariaLabel="Shipping Last Name"
                            />
                        </div>
                    </div>

                    {/* companyName */}
                    <div className="row">
                        {(store.checkout.ship.addressType === ICheckoutAddressType.business || store.checkout.ship.addr.addrShowMoreCompany) && (
                            <div className="col-12">
                                <CheckoutInputElement
                                    floating={true}
                                    ab={store.checkout.ab}
                                    o={store.checkout.ship.addr.companyName}
                                    required={false}
                                    ariaLabel="Shipping Company"
                                />
                            </div>
                        )}
                    </div>

                    {/* address line 1 */}
                    <div className="row">
                        <div className="col-12">
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.address1}
                                required={true}
                                places={true}
                                ariaLabel="Shipping Address Line 1"
                            />
                        </div>
                    </div>

                    {/* address line 2 */}
                    <div className="row">
                        {store.checkout.ship.addr.addrShowMore && (
                            <div className="col-12">
                                <CheckoutInputElement
                                    floating={true}
                                    ab={store.checkout.ab}
                                    o={store.checkout.ship.addr.address2}
                                    required={false}
                                    placeholder="Apartment, suite, unit, building, floor, etc"
                                    ariaLabel="Shipping Address Line 2"
                                />
                            </div>
                        )}
                        {!store.checkout.ship.addr.addrShowMore && (
                            <div className="col-12">
                                <button
                                    className="add-more text-btn"
                                    onClick={this.syncMore}
                                    type="button"
                                    aria-label="Add shipping address line 2"
                                >
                                    + Add Address Line 2
                                </button>
                            </div>
                        )}
                        {!store.checkout.ship.addr.addrShowMoreCompany && (
                            <div className="col-12">
                                <button
                                    className="add-more text-btn"
                                    onClick={this.syncMoreCompany}
                                    type="button"
                                    aria-label="Add shipping company"
                                >
                                    + Add Company
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="row pad-top">
                        {/* city */}
                        <div className={this.isCountryWithStates ? 'col-12 col-sm-4 col-lg-4' : 'col-12 col-sm-4'}>
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.city}
                                required={true}
                                ariaLabel="Shipping City"
                            />
                        </div>

                        {/* state */}
                        <div className={this.isCountryWithStates ? 'col-12 col-sm-5 col-lg-3' : 'col-12 col-sm-4'}>
                            {store.checkout.ab < 0 && <div className={this.focusedState ? 'input-label input-label-focused' : 'input-label'}>* State/Region</div>}
                            {this.isCountryWithStates && (
                                <div className="form-floating">
                                    <select
                                        onFocus={() => (this.focusedState = true)}
                                        onBlur={() => (this.focusedState = false)}
                                        name="shipping-states"
                                        className="form-select"
                                        value={store.checkout.ship.addr.state.value}
                                        onChange={this.handleChangeShippingState}
                                        autoComplete="shipping address-level1"
                                        aria-label="Shipping State or Region"
                                    >
                                        {store.checkout.ship.addr.country.value === 'US' &&
                                            data.states
                                                .filter(e => e.cid === 217)
                                                .map(e => (
                                                    <option
                                                        value={e.ddl}
                                                        key={e.id}
                                                        data-id={e.id}
                                                    >
                                                        {e.name}
                                                    </option>
                                                ))}
                                        {store.checkout.ship.addr.country.value === 'CA' &&
                                            data.states
                                                .filter(e => e.cid === 39)
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map(e => (
                                                    <option
                                                        value={e.code}
                                                        key={e.id}
                                                        data-id={e.id}
                                                    >
                                                        {e.name}
                                                    </option>
                                                ))}
                                        {store.checkout.ship.addr.country.value === 'DE' &&
                                            data.states
                                                .filter(e => e.cid === 78)
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map(e => (
                                                    <option
                                                        value={e.code}
                                                        key={e.id}
                                                        data-id={e.id}
                                                    >
                                                        {e.name}
                                                    </option>
                                                ))}
                                        {store.checkout.ship.addr.country.value === 'GB' &&
                                            data.states
                                                .filter(e => e.cid === 216)
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map(e => (
                                                    <option
                                                        value={e.code}
                                                        key={e.id}
                                                        data-id={e.id}
                                                    >
                                                        {e.name}
                                                    </option>
                                                ))}
                                        {store.checkout.ship.addr.country.value === 'JP' &&
                                            data.states
                                                .filter(e => e.cid === 104)
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map(e => (
                                                    <option
                                                        value={e.code}
                                                        key={e.id}
                                                        data-id={e.id}
                                                    >
                                                        {e.name}
                                                    </option>
                                                ))}
                                    </select>
                                    <label htmlFor="shipping-states">State or Region</label>
                                </div>
                            )}
                            {!this.isCountryWithStates && (
                                <div className="form-floating">
                                    <input
                                        value={store.checkout.ship.addr.state.value}
                                        onChange={e => (store.checkout.ship.addr.state.value = e.target.value)}
                                        onFocus={() => (this.focusedState = true)}
                                        onBlur={() => (this.focusedState = false)}
                                        className="form-control"
                                        placeholder="State/Region"
                                        type="text"
                                        autoComplete="shipping address-level1"
                                        aria-label="Shipping State or Region"
                                        name="shipping-region"
                                        id="shipping-region"
                                    />
                                    <label htmlFor="shipping-region">State or Region</label>
                                </div>
                            )}
                            {store.checkout.ship.addr.state.valid.isError && (
                                <div
                                    className="error"
                                    style={{
                                        color: '#FE0000',
                                        paddingLeft: '17px',
                                        fontSize: '14px',
                                    }}
                                >
                                    {store.checkout.ship.addr.state.valid.msg}
                                </div>
                            )}
                        </div>

                        {/* postal code */}
                        <div className={this.isCountryWithStates ? 'col-12 col-sm-3 col-lg-5 col-postal-code' : 'col-12 col-sm-4 col-postal-code'}>
                            <CheckoutInputElement
                                floating={true}
                                ab={store.checkout.ab}
                                o={store.checkout.ship.addr.postalCode}
                                type="text"
                                required={true}
                                hideSpinner={true}
                                ariaLabel="Shipping Postal Code"
                            />
                        </div>

                        {/* country */}
                        <div className={'col-12'}>
                            {store.checkout.ab < 0 && <div className={this.focusedCountry ? 'input-label input-label-focused' : 'input-label'}>* Country</div>}
                            <div className="form-floating">
                                <select
                                    className="form-select"
                                    name="shipping-country"
                                    onFocus={() => (this.focusedCountry = true)}
                                    onBlur={() => (this.focusedCountry = false)}
                                    autoComplete="shipping country"
                                    value={store.checkout.ship.addr.country.value}
                                    aria-label="Shipping Country"
                                    onChange={this.handleChangeCountry}
                                >
                                    {data.countries.map(e => (
                                        <option
                                            value={e.code}
                                            key={e.id}
                                        >
                                            {e.name}
                                        </option>
                                    ))}
                                </select>
                                <label htmlFor="shipping-country">Country</label>
                            </div>
                            {store.checkout.ship.addr.country.valid.isError && (
                                <div
                                    className="error"
                                    style={{
                                        color: '#FE0000',
                                        paddingLeft: '17px',
                                        fontSize: '14px',
                                    }}
                                >
                                    {store.checkout.ship.addr.country.valid.msg}
                                </div>
                            )}
                        </div>

                        <div className="col-12 col-md-6 text-left mt-1">
                            <label className="radio-container">
                                <input
                                    type="checkbox"
                                    aria-label="Business Address"
                                    className="radio radio-sm"
                                    name="shipping-business-address"
                                    value={1}
                                    checked={store.checkout.ship.addr.isBusinessAddress}
                                    onChange={() => (store.checkout.ship.addr.isBusinessAddress = !store.checkout.ship.addr.isBusinessAddress)}
                                />
                                <span className="radio-label">Business Address</span>
                            </label>
                        </div>

                        <div className="col-12 col-md-6 text-right mt-1">
                            <ModalSimple
                                id="modal-apo"
                                title={'Military APO, FPO, or DPO Address Tips'}
                            >
                                <div>
                                    <div className="b">Address Field</div>
                                    <div>For Army, Navy, and Marines enter your unit # and box #</div>
                                    <div>For ships, enter the ship name and hull #</div>
                                    <div>For Air Force, enter the PSC # and box #</div>

                                    <div className="b mt-2">City Field</div>
                                    <div>Enter APO for Air/Army Post Office</div>
                                    <div>Enter FPO for Fleet Post Office</div>
                                    <div>Enter DPO for Diplomatic Post Office</div>

                                    <div className="b mt-2">Stage/Region Field</div>
                                    <div>Armed Forces Africa (AE)</div>
                                    <div>Armed Forces Americas (AA)</div>
                                    <div>Armed Forces Canada (AE)</div>
                                    <div>Armed Forces Europe (AE)</div>
                                    <div>Armed Forces Middle East (AE)</div>
                                    <div>Armed Forces Pacific (AP)</div>

                                    <div className="b mt-2">Sample Military Address #1</div>
                                    <div>CPT ROBERT SMITH</div>
                                    <div>UNIT 2050 BOX 4190</div>
                                    <div>APO AP 96278</div>

                                    <div className="b mt-2">Sample Military Address #2</div>
                                    <div>SEAMAN JOSEPH SMITH</div>
                                    <div>USCGC HAMILTON</div>
                                    <div>FPO AP 96667</div>
                                </div>
                            </ModalSimple>
                            <button
                                className="link text-btn"
                                style={{fontSize: 12}}
                                onClick={() => modalOpen('modal-apo')}
                                aria-label="View Military APO / FPO / DPO address tips"
                                type="button"
                            >
                                Military (APO &amp; FPO) or DPO Address Tips
                            </button>
                        </div>
                    </div>

                    {store.checkout.ship.messages.map((e, i) => (
                        <div
                            className="alert alert-danger"
                            key={i.toString()}
                            style={{marginTop: 8}}
                        >
                            <span style={{paddingRight: 6}}>
                                <i
                                    className="fas fa-exclamation-square"
                                    aria-hidden={true}
                                ></i>
                            </span>{' '}
                            {e.msg}
                        </div>
                    ))}

                    <div className="row row-ship-continue">
                        {store.checkout.cstep === ICheckoutStep.shipping && (
                            <div className="col-12 text-right">
                                <div
                                    aria-live="assertive"
                                    aria-atomic="true"
                                    className="sr-only"
                                >
                                    {this.loading ? 'Calculating shipping price' : ''}
                                </div>
                                <button
                                    type="button"
                                    className={`btn-checkout btn-checkout-yellow${store.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
                                    onClick={this.save}
                                    disabled={this.loading}
                                    aria-busy={this.loading}
                                    aria-label="Save and Continue"
                                >
                                    {!this.loading ? 'Save & Continue' : 'Calculating'}
                                    {this.loading && (
                                        <span className="pad-left">
                                            <i className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"></i>
                                        </span>
                                    )}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
